import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// components
import Sidebar from "components/Sidebar/Sidebar.js";
import CardFullTable from "components/Cards/Admin/CardFullTable.js";
// texts as props
import sidebar from "_texts/admin/sidebar/sidebar.js";
import { useDispatch, useSelector } from "react-redux";
import { getWorkflows } from "actions/workflows";

const Workflows = ({ navigation }) => {
  const location = useLocation();
  const workflows = useSelector((state) => state.workflows.workflows);
  const dispatch = useDispatch();
  const [body, setBody] = useState([]);
  const [head, setHead] = useState([]);
  const [retrievedWorkflows, setRetrievedWorkflows] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (workflows.length === 0 && !retrievedWorkflows) {
      setRetrievedWorkflows(true);
      dispatch(getWorkflows());
    } else {
      console.log("WORKFLOWS: ", workflows);
      const keys = [
        "id",
        "public_id",
        "name",
        "workflow_type",
        "description",
        "actions",
      ];
      setHead(keys);
      setBody(
        workflows.map((workflow) => {
          const values = [
            workflow.id,
            workflow.public_id,
            workflow.name,
            workflow.workflow_type,
            workflow.description,
            <></>,
          ];
          return values;
        })
      );
    }
  }, [workflows, retrievedWorkflows, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const editworkflow = (row) => {
    const workflow = {};
    head.forEach((key, index) => {
      workflow[key] = row[index];
    });
    //NiceModal.show('add-workflow', {workflow: workflow});
    navigate(`/admin/workflow/${workflow.public_id}`);
  };

  return (
    <>
      <Sidebar {...sidebar} />
      <div
        className="relative md:ml-64 bg-blueGray-100 pt-24"
        style={{ height: "100%", minHeight: "100vh" }}
      >
        <div className="px-4 md:px-6 mx-auto w-full -mt-24 pt-24">
          <div className="flex flex-wrap">
            <div className="w-full px-4">
              <CardFullTable
                title="Workflows"
                titlebutton={
                  <i
                    onClick={() => navigate("/admin/workflow/")}
                    className="fa fa-plus text-sm cursor-pointer"
                  />
                }
                head={head}
                body={body}
                color="white"
                onRowClick={(row) => editworkflow(row)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Workflows;
